module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-hide"
  }, [_c('div', {
    staticClass: "load-hide",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "context cq_context"
  }, [_c('div', {
    staticClass: "title two-picture"
  }, [_c('div', {
    staticClass: "setup_icon"
  }, [_c('span', {
    on: {
      "click": _vm.goSetup
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "erweima-img",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "id": "qrCodeImg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "two_bottom"
  }, [_c('p', {
    staticClass: "the_number_card"
  }, [_vm._v("No." + _vm._s(_vm.card_num))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#cb0000",
      "margin": "0"
    }
  }, [_c('span', {
    staticClass: "card_making_icon",
    on: {
      "click": _vm.reloads
    }
  }), _vm._v("¥ " + _vm._s(_vm.ava_balance))])])]), _vm._v(" "), _c('div', {
    staticClass: "get_now"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "充值"
    },
    on: {
      "click": _vm.goRecharge
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "get_now"
  }, [_c('input', {
    attrs: {
      "type": "button",
      "value": "账单"
    },
    on: {
      "click": _vm.goBill
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title_img"
  }, [_c('hr'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/img/freshone.png")
    }
  }), _vm._v(" "), _c('hr')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ad0775c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/main/views/card_qrcode.vue
// module id = 206
// module chunks = 1